exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".voucher-preview {\n  width: 100%;\n  height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["C://Users//T.ETTLING//Desktop//VirGroup Webseiten//src//scss"]}!./src/pages/VoucherPage.scss
// module id = 924
// module chunks = 0